export enum ProgramMembership {
  Agronomy = 'agronomy',
  Both = 'both',
  Energy = 'energy',
}
